var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6316 7.63137C15.2354 7.23519 15.0373 7.0371 14.9631 6.80869C14.8978 6.60776 14.8978 6.39135 14.9631 6.19042C15.0373 5.96201 15.2354 5.76392 15.6316 5.36774L18.4706 2.52878C17.7173 2.18821 16.881 1.99861 16.0002 1.99861C12.6865 1.99861 10.0002 4.6849 10.0002 7.99861C10.0002 8.48963 10.0592 8.9668 10.1705 9.42348C10.2896 9.91229 10.3492 10.1567 10.3386 10.3111C10.3275 10.4728 10.3034 10.5589 10.2289 10.7027C10.1577 10.8401 10.0212 10.9766 9.74824 11.2495L3.50016 17.4976C2.6717 18.3261 2.6717 19.6692 3.50016 20.4976C4.32859 21.3261 5.67174 21.3261 6.50016 20.4976L12.7482 14.2496C13.0212 13.9766 13.1577 13.8401 13.2951 13.7689C13.4389 13.6944 13.525 13.6703 13.6867 13.6592C13.8411 13.6486 14.0855 13.7082 14.5743 13.8273C15.031 13.9386 15.5082 13.9976 15.9992 13.9976C19.3129 13.9976 21.9992 11.3113 21.9992 7.99761C21.9992 7.11681 21.8096 6.28049 21.469 5.52722L18.6301 8.36616C18.2339 8.76234 18.0358 8.96044 17.8074 9.03465C17.6064 9.09994 17.39 9.09994 17.1891 9.03465C16.9607 8.96044 16.7626 8.76234 16.3664 8.36616L15.6316 7.63137Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool02);
export default __webpack_public_path__ + "static/media/tool-02.e40cec7c82d7c60704675d608c6629f0.svg";
export { ForwardRef as ReactComponent };